module.exports = __webpack_public_path__ + "static/media/ImportedSuccess.d75d276f.svg";